module.exports = __webpack_public_path__ + "65337a0ce4271fb7644909717b32302c.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/794.png
// module id = 1702
// module chunks = 2